import { useRef, useState } from "react";

/*
 * This hook is used to manage a list of objects in the state.
 */
export const useListState = (initialState: Array<any> = []) => {
	const [listWithUniqueIds, setListWithUniqueIds] = useState<{ uniqueListId: number; state: any }[]>(
		initialState.map((state, index) => ({ uniqueListId: index + 1, state: state }))
	);

	const largestUniqueId = useRef<number>(initialState.length);

	const getNewUniqueId = () => {
		largestUniqueId.current += 1;
		return largestUniqueId.current;
	};

	const append = (item: any) => {
		setListWithUniqueIds([...listWithUniqueIds, { uniqueListId: getNewUniqueId(), state: item }]);
	};

	const push = (item: any) => {
		setListWithUniqueIds([{ uniqueListId: getNewUniqueId(), state: item }, ...listWithUniqueIds]);
	};

	const remove = (removeIndex: number) => {
		setListWithUniqueIds(listWithUniqueIds.filter((_, index) => index !== removeIndex));
	};

	const update = (index: number, item: any) => {
		setListWithUniqueIds((existingItems) => [
			...existingItems.slice(0, index),
			{ state: item, uniqueListId: existingItems[index].uniqueListId },
			...existingItems.slice(index + 1),
		]);
	};

	const clear = () => {
		setListWithUniqueIds(initialState.map((state) => ({ uniqueListId: getNewUniqueId(), state: state })));
	};

	const setList = (newList: any[]) => {
		setListWithUniqueIds(newList.map((state) => ({ uniqueListId: getNewUniqueId(), state: state })));
	};

	const getIndexFromUniqueId = (uniqueId: number) => {
		return listWithUniqueIds.findIndex((item) => item.uniqueListId === uniqueId);
	};

	const list = listWithUniqueIds.map((item) => item.state);

	return {
		listWithUniqueIds: listWithUniqueIds || [],
		list: list || [],
		setList,
		append,
		push,
		remove,
		update,
		clear,
		getIndexFromUniqueId,
	};
};
